import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ValentineZikkiPortfolio from './ValentineZikkiPortfolio';
import ForumCivLogo from '../assets/images/forumciv.jpeg';
import BraidFundLogo from '../assets/images/braidfund.jpeg';
import NewsletterSignup from '../components/NewsletterSignup';
import FounderStatement from './FounderStatement';

const Home = () => {
  const [heroIndex, setHeroIndex] = useState(0);
  const [fadeIn, setFadeIn] = useState(true);

  const heroLines = [
    // "Karibu ZIRAYA Institute!",
    // "Research. Safeguarding. Creative Futures.",
    // "Creative brilliance is often neurodivergent.",
    // "Neurodivergence is often unsupported.",
    // "Unsupported brilliance becomes burnout.",
    // "Creativity deserves systems that sustain it.",
    // "Artistic knowledge deserves to be remembered."
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setFadeIn(false);
      setTimeout(() => {
        setHeroIndex((prevIndex) => (prevIndex + 1) % heroLines.length);
        setFadeIn(true);
      }, 500);
    }, 5000);

    return () => clearInterval(interval);
  }, [heroLines.length]);

  return (
    <>
      {/* Hero Section with Background Image */}
      <section className={`hero home-hero ${heroLines.length === 0 ? 'hero-no-text' : ''}`}>
        {/* Background Image with Overlay */}
        <div className="hero-background">
          <div className="hero-overlay"></div>
        </div>

        <div className="container">
          <div className={`hero-content ${heroLines.length === 0 ? 'no-hero-text' : ''}`}>
            {heroLines.length > 0 && (
              <h1 className={`hero-line ${fadeIn ? 'fade-in' : 'fade-out'}`}>
                {heroLines[heroIndex]}
              </h1>
            )}

            {/* New Hero Subtitle */}
            {/* <p className="hero-subtitle">
              A research, artistic, and advocacy institute exploring sustainable creative ecosystems through cultural memory, neuro-inclusion, safeguarding, technology, and African futures
            </p> */}

            {/* Founder Introduction */}
            {/* <p className="hero-founder">
              <strong>Valentine Zikki — Creative researcher, cultural practitioner, and founder of ZIRAYA Institute.</strong>
            </p> */}

            <div className="hero-btns">
              <a href="/downloads/fichua-pazia-toolkit.pdf" className="btn btn-secondary" target="_blank" rel="noopener noreferrer">View Fichua Pazia Toolkit</a>
              <a href="/research-journal" className="btn btn-secondary">Explore Research Journal</a>
            </div>

            <div className="hero-secondary-links">
              <Link to="/projects" className="text-link">See previous projects</Link>
              <span className="separator">•</span>
              <Link to="/about" className="text-link">About Ziraya</Link>
              <span className="separator">•</span>
              <Link to="/workshops-and-training" className="text-link">Workshops & Training</Link>
            </div>
          </div>
        </div>
      </section>

      {/* What We Do - Three Pillars Section */}
      <section className="what-we-do  bg-deep-navy">
        <div className="container">
          <h2 className="section-title-centered">What We Do</h2>

          <div className="pillars-grid">
            {/* Research Pillar */}
            <div className="pillar-card">
              <div className="pillar-icon">
                <i className="fas fa-microscope"></i>
              </div>
              <h3>Research</h3>
              <p>Investigating artistic sustainability, cultural memory,
                neurodiversity, technology,
                and the systems that shape African creative futures.</p>
            </div>

            {/* Advocacy Pillar */}
            <div className="pillar-card">
              <div className="pillar-icon">
                <i className="fas fa-gavel"></i>
              </div>
              <h3>Advocacy</h3>
              <p>Developing experimental artistic works that explore performance,
                technology, and new forms of storytelling.</p>
            </div>

            {/* Creative Practice Pillar */}
            <div className="pillar-card">
              <div className="pillar-icon">
                <i className="fas fa-paint-brush"></i>
              </div>
              <h3>Creative Practice</h3>
              <p>Developing experimental artistic and storytelling projects exploring human–AI collaboration.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Statement */}
      <section className="mission-statement bg-dark">
        <h2 className="block-title">Why Ziraya Exists</h2>
        <div className="container">
          <blockquote>
            "ZIRAYA was born from the gaps I, and many creatives like me,
            have experienced and witnessed — the need for safer spaces, inclusive systems,
            sustainable careers,
            and structures that preserve our creative knowledge for future generations."
          </blockquote>
          <p className="quote-author">— Valentine Zikki, Founder & Lead Researcher, ZIRAYA Institute</p>
        </div>
      </section>

      <section className="portfolio-preview-section  bg-deep-navy">
        <FounderStatement isPreview={true} />
      </section>


      {/* Featured Projects Section */}
      <section className="featured-projects  bg-dark">
        <div className="container">
          <div className="section-title">
            <h2>Current Initiatives</h2>
          </div>

          <div className="projects-grid">
            {/* Spectrum Creatives */}
            <div className="project-card">
              <div className="project-image spectrum-creatives">

              </div>
              <div className="project-content">
                <h3><Link to="/project/spectrum-creatives">Spectrum Creatives</Link></h3>
                <p>Supporting neurodivergent creatives through workshops, resources, and curated events.</p>
                <div className="project-tags">
                  <span className="tag">Spectrum</span>
                  <span className="tag">Open Studio Sessions</span>
                </div>
                <Link to="/project/spectrum-creatives" className="text-link">Learn more →</Link>
              </div>
            </div>

            {/* Fichua Pazia */}
            <div className="project-card">
              <div className="project-image fichua-pazia">
              </div>
              <div className="project-content">
                <h3><Link to="/project/fichua-pazia-unmask">Fichua Pazia (Unmask) </Link></h3>
                <p>Safeguarding toolkit and research project ensuring creatives operate in safe, ethical spaces.</p>
                <div className="project-tags">
                  <span className="tag">Safeguarding</span>
                  <span className="tag">Toolkit</span>
                </div>
                <Link to="/project/fichua-pazia-unmask" className="text-link">Learn more →</Link>
              </div>
            </div>

            {/* Mpenzi Mashini */}
            <div className="project-card">
              <div className="project-image mpenzi-mashini">
              </div>
              <div className="project-content">
                <h3><Link to="/project/mpenzi-mashini">Mpenzi Mashini (Dear Machine) </Link></h3>
                <p>One-woman hybrid play integrating AI and human performance. Exploring intimacy, authorship, and ethical AI collaboration.</p>
                <div className="project-tags">
                  <span className="tag">Hybrid Dramaturgy</span>
                  <span className="tag">Performance</span>
                </div>
                <Link to="/project/mpenzi-mashini" className="text-link">Learn more →</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Research Journal Preview */}
      <section className="journal-preview bg-deep-navy">
        <div className="container">
          <div className="section-title">
            <h2>Research Journal</h2>
            <p>Documenting research, insights, and emerging questions at the intersection of creativity, culture, technology, inclusion, and social change.</p>
          </div>

          <div className="journal-entries-preview">
            {/* Theatre Sustainability */}
            <div className="journal-card">
              <span className="research-tag"><a href="/journal/from-survival-to-sustainability">Theatre Sustainability & Cultural Memory</a></span>
              <h3>
                <Link to="/journal/from-survival-to-sustainability">FROM SURVIVAL TO SUSTAINABILITY: A Study of Continuity, Institutional Memory, and Artist Livelihoods in Kenyas Theatre Ecosystem</Link>
              </h3>
              <p className="abstract">
                {/* An ongoing study investigating artist livelihoods, knowledge transfer, documentation, 
                and institutional continuity within Kenya’s theatre ecosystem.
              */}</p>
              <Link to="/journal/from-survival-to-sustainability" className="text-link">Read more →</Link>
            </div>

            {/* Neurodivergence & AI */}
            <div className="journal-card">
              <span className="research-tag"><a href="/journal/neuro-arts">Neurodivergence & Creative Practice</a></span>
              <h3>
                <Link to="/journal/neuro-arts">NeuroArts</Link>
              </h3>
              <p className="abstract">
                NeuroArts is an emerging research initiative at Ziraya Institute that investigates how neurodivergent creatives experience, navigate, and transform artistic practice.
              </p>
              <Link to="/journal/neuro-arts" className="text-link">Read more →</Link>
            </div>

            <div className="journal-card">
              <span className="research-tag"><a href="/journal/fichua-pazia-research">Industry Safeguarding</a></span>
              <h3>
                <Link to="/journal/fichua-pazia-research">Fichua Pazia Research</Link>
              </h3>
              <p className="abstract">
                Fichua Pazia is an initiative under the Ziraya Institute that seeks to create safer, more equitable work environments within Kenya's creative sector.
              </p>
              <Link to="/journal/fichua-pazia-research" className="text-link">Read more →</Link>
            </div>

            {/* Hybrid Dramaturgy */}
            <div className="journal-card">
              <span className="research-tag"><a href="/journal/msichana-wa-ai">African Women in AI</a></span>
              <h3>
                <Link to="/journal/msichana-wa-ai">Msichana wa AI: Culture, AI and Storytelling</Link>
              </h3>
              <p className="abstract">
                Exploring how artificial intelligence is shaping culture, creativity, and everyday life in Kenya, with a focus on gender, technology, and storytelling.
              </p>
              <Link to="/journal/msichana-wa-ai" className="text-link">Read more →</Link>
            </div>
          </div>
        </div>
      </section>

      <NewsletterSignup variant="default" />

      {/* On-Site Safeguarding Support CTA */}
      <section className="onsite-support bg-deep-navy">
        <div className="container">
          <div className="onsite-support-container">
            <div className="onsite-support-tagline">
              <h2>Because Brilliant Art Deserves Safe Spaces</h2>
              <p className="onsite-support-subtitle">On-Site Safeguarding Support</p>
            </div>

            <div className="onsite-support-content">
              <p className="onsite-support-description">
                Would you like us to visit your set, studio, or creative workspace? We provide on-site guidance and support to foster safer, inclusive, and respectful creative environments for everyone.
              </p>

              <div className="onsite-support-contact">
                <div className="contact-detail">
                  <i className="fas fa-envelope"></i>
                  <a href="mailto:partnerships@zirayainstitute.org">partnerships@zirayainstitute.org</a>
                  <span className="separator">/</span>
                  <a href="mailto:habari@zirayainstitute.org">habari@zirayainstitute.org</a>
                </div>
                <div className="contact-detail">
                  <i className="fas fa-phone-alt"></i>
                  <span>0747 816 126 / 0725 816 126</span>
                </div>
              </div>

              <div className="onsite-support-cta">
                <a href="mailto:habari@zirayainstitute.org?subject=On-Site%20Safeguarding%20Support%20Request" className="btn btn-large">
                  Request On-Site Support
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Previous Funders & Supporters Section  */}
      <section className="funders-section bg-dark">
        <div className="container">
          <h2 className="section-title-centered">Previous Funders & Supporters</h2>

          <div className="funders-grid">
            {/* ForumCiv */}
            <div className="funder-card">
              <div className="funder-logo forumciv-logo">
                <img src={ForumCivLogo} alt="ForumCiv Logo" className="funder-logo-image" />
              </div>
              <div className="funder-description">
                <p><strong>ForumCiv</strong> – Funded the project <em>Safer Workspaces in the Creative Sector</em>, which led to the development of Kenya’s first industry-specific safeguarding toolkit, <em>Fichua Pazia</em>, advancing safer, more inclusive environments for creatives.</p>
              </div>
            </div>

            {/* Braid Fund */}
            <div className="funder-card">
              <div className="funder-logo braid-logo">
                <img src={BraidFundLogo} alt="Braid Fund Logo" className="funder-logo-image" />
              </div>
              <div className="funder-description">
                <p><strong>Braid Fund</strong> – Supported <em>Mpenzi Mashini (Dear Machine)</em>, exploring hybrid AI-human dramaturgy.</p>
              </div>
            </div>
          </div>

          <div className="funders-statement">
            <p className="partnership-text">
              These partnerships reflect ZIRAYA Institute’s commitment to innovation, advocacy, and ethical creative practice.
            </p>
          </div>
        </div>
      </section>

    </>
  );
};

export default Home;